import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

const etrongt: PartialCarConfiguration = {
	combinations: ['trimLine', 'packages', 'paint', 'rims', 'headlights', 'interior', 'steeringWheels'],
};

const setrongt: PartialCarConfiguration = {
	...etrongt,
};

const rsetrongt: PartialCarConfiguration = {
	...etrongt,
};

const rsetrongtperformance: PartialCarConfiguration = {
	...etrongt,
};

const etrongt_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const setrongt_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const rsetrongt_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};
const rsetrongtperformance_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

export {
	etrongt,
	etrongt_ui,
	rsetrongt,
	rsetrongt_ui,
	rsetrongtperformance,
	rsetrongtperformance_ui,
	setrongt,
	setrongt_ui,
};
